import { createFileRoute } from '@tanstack/react-router'

import SystemSettings from '@/features/Admin/SystemSettings'
import { RouteErrorComponent } from '@/shared/RouteErrorComponent/RouteErrorComponent.tsx'

export const Route = createFileRoute('/_authenticated/admin/system-settings')({
    component: RouteComponent,
    onError: RouteErrorComponent,
})

function RouteComponent() {
    return <SystemSettings />
}
